import { Component, EventEmitter, Input, Output } from "@angular/core";
import { User } from "../models/user.model";
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
  AbstractControl,
  ValidationErrors,
} from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { PasswordValidationService } from "../../shared/services/password-validation.service";

@Component({
  selector: "re-user-detail-actions-modal",
  standalone: false,
  templateUrl: "./user-detail-actions-modal.component.html",
  styleUrl: "./user-detail-actions-modal.component.scss",
})
export class UserDetailActionsModalComponent {
  @Input() user: User = new User();
  @Input() userAction: string;
  @Output() userDetailActionsEvent: EventEmitter<string> = new EventEmitter();
  @Output() copyActionEvent: EventEmitter<string> = new EventEmitter();
  @Output() temporaryPasswordActionEvent: EventEmitter<string> =
    new EventEmitter();
  @Input() temporaryPassword: string;

  constructor(
    public activeModal: NgbActiveModal,
    private passwordValidationSvc: PasswordValidationService,
  ) {}

  fgPassword = new UntypedFormGroup({
    passwordCtl: new UntypedFormControl(null, [
      Validators.required,
      (control: AbstractControl) => this.passwordComplexityValidator(control),
    ]),
  });

  /**
   * Determines if deactivation should be blocked for Physician/NPPA users
   * who have facility assignments
   */
  get shouldBlockDeactivation(): boolean {
    return (
      this.user.facilityRoleAssignments?.length > 0 &&
      this.user.physicianNppaEnabled
    );
  }

  submitModal(action: string) {
    this.userDetailActionsEvent.emit(action);
  }

  copyAction(action: string) {
    this.copyActionEvent.emit(action);
  }

  temporaryPasswordAction(action: string) {
    this.temporaryPasswordActionEvent.emit(action);
    this.activeModal.close("Cancel click");
  }

  passwordComplexityValidator(
    control: AbstractControl,
  ): ValidationErrors | null {
    if (control.value !== null) {
      let valid = this.passwordValidationSvc
        .validatePassword(
          control.value,
          this.user.userName,
          null,
          this.user.firstName,
          this.user.lastName,
          true,
          true,
          true,
        )
        .isValid();

      if (!valid) return { complex: true };
    }

    return null;
  }
}
